import { render, staticRenderFns } from "./LogKendaraan.vue?vue&type=template&id=5ec2af5e&scoped=true&"
import script from "./LogKendaraan.vue?vue&type=script&lang=js&"
export * from "./LogKendaraan.vue?vue&type=script&lang=js&"
import style0 from "./LogKendaraan.vue?vue&type=style&index=0&id=5ec2af5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec2af5e",
  null
  
)

export default component.exports